
import React, { useState, useEffect, useReducer } from 'react'

import {
    Dialog, DialogContent, DialogActions, DialogTitle, Divider, Tooltip, Button,
    FormControl, InputLabel, Select, MenuItem, TextField, Chip
} from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton';
import CloseIcon from '@mui/icons-material/Close'
import defaultReducer from '../../../../../utils/defaultReducer'
import { getSession } from '../../../../../auth'
import api from '../../../../../api'
import Loading from '../../../../Loading'
import style from './styles.module.css'
import { selectionStateInitializer } from '@mui/x-data-grid/internals';
import VariableTextField from '../../../../Input/VariableTextField'
import { FileDrop } from 'react-file-drop';
import ImportIcon from '@mui/icons-material/Upload';
import useNotification from '../../../../Notification'


export const MessageFormat = Object.freeze({
    TEXT: 0,
    MEDIA: 1,
})

export const getScoutDefaultState = {
    accounts: [],
    format: MessageFormat.TEXT,
    message: "",
    caption: null,
    media: null,
    account_id: null,
    media_url: "",
};

const enterpriseId = getSession()?.profile?.enterprise?.id

const getScoutConfs = async (setState, setLoading) => {
    setLoading(true)
    const params = new URLSearchParams({
        fullFetch: 0,
    });

    const res = await api.get(
        `api/enterprises/${enterpriseId}/scout_accounts/?${params.toString()}`,
    );

    setLoading(false)
    if (res.status === 200)
        return setState({ accounts: res.data })
    return false
}

const submit = async (state, close, setLoading) => {

    setLoading(true)
    const url = `api/enterprises/${enterpriseId}/scout_accounts/${state.account_id}/notification`
    const payload = new FormData();

    payload.append('contacts', JSON.stringify(state.contacts));

    if (state.format === MessageFormat.TEXT) {
        payload.message = state.message;
        payload.append('message', state.message);
    }
    else if (state.format === MessageFormat.MEDIA && state.media) {
        payload.append('media', state.media)
        payload.append('message', state.caption)
    } else if (state.format === MessageFormat.MEDIA && state.media_url) {
        payload.append('media_url', state.media_url)
        payload.append('message', state.caption)
    } else {
        await useNotification(
            "Ops",
            "Requisição inválida.",
            "danger"
        );
        setLoading(false);
        return
    }

    const res = await api.post(url, payload);


    
    setLoading(false);
    useNotification(
        'Sucesso!',
        'Mensagem enviada aos contatos selecionados.',
        'success'
    );
    close()
    return 
}

export const SendScoutContent = ({ setParent, parent, setLoading }) => {
    useEffect(() => {
        getScoutConfs(setParent, setLoading);
    }, []);

    return (
      <>
        <FormControl fullWidth size="small">
          <InputLabel id="scout-simple-select-label">Origem</InputLabel>
          <Select
            labelId="scout-simple-select-label"
            id="scout-simple-select"
            label="Origem"
            onChange={({ target }) => setParent({ account_id: target.value })}
            value={parent.account_id}
            size="small"
          >
            <MenuItem key="default-selected-scout" value={""}>
              Selecione*
            </MenuItem>
            {parent.accounts.map(({ id, name }) => (
              <MenuItem key={`${id}-select-scout`} value={id}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth size="small">
          <InputLabel id="scout-format-select-label">Formato</InputLabel>
          <Select
            labelId="scout-format-select-label"
            id="scout-format-select"
            label="Formato"
            onChange={({ target }) => setParent({ format: target.value })}
            value={parent.format}
            size="small"
          >
            <MenuItem
              key="default-selected-scout-format"
              value={MessageFormat.TEXT}
            >
              Texto
            </MenuItem>
            <MenuItem
              key="default-selected-scout-format-media"
              value={MessageFormat.MEDIA}
            >
              Mídia
            </MenuItem>
          </Select>
        </FormControl>
        {parent.format === MessageFormat.TEXT && (
          <FormControl fullWidth size="small">
            <VariableTextField
              id="scout-message-textarea"
              multiline
              rows={10}
              size="small"
              label="Mensagem"
              fullWidth
              type="text"
              variant="outlined"
              inputProps={{ maxLength: 1024 }}
              value={parent.message}
              onChange={(event) => setParent({ message: event.target.value })}
              onVariableSelect={(value) =>
                setParent({ message: `${parent.message} ${value}` })
              }
            />
          </FormControl>
        )}
        {parent.format === MessageFormat.MEDIA && (
          <>
            <FormControl fullWidth size="small">
              <div className="file-drop-container">
                <FileDrop
                  onDrop={(files, event) => setParent({ media: files[0] })}
                >
                  {parent.file ? (
                    <Chip
                      label={parent.file.name}
                      onDelete={setParent({ media: null })}
                    />
                  ) : (
                    <span>[1] Arraste e solte para inserir a mídia.</span>
                  )}
                  <span>ou</span>
                  <LoadingButton
                    variant="contained"
                    color="primary"
                    component="label"
                    loading={false}
                    loadingPosition="start"
                    startIcon={<ImportIcon />}
                    disabled={false}
                    onClick={() => {}}
                  >
                    Selecione a mídia
                    <input
                      hidden
                      accept={'image/*,video/*,audio/*,document/*'}
                      type="file"
                      onChange={(e) => setParent({ media: e.target.files[0]})}
                    />
                  </LoadingButton>
                  <span style={{ margin: "8px 0px" }}>ou</span>
                  <Tooltip
                    title={`Alternativamente ao arquivo, coloque a URL da mídia`}
                  >
                    <TextField
                      label="URL"
                      size="small"
                    //   disabled={file}
                      value={parent.media_url || ''}
                      onChange={({ target }) => setParent({ media_url: target.value })}
                    />
                  </Tooltip>
                </FileDrop>
              </div>
            </FormControl>
          </>
        )}
      </>
    );
};

export const ShouldSendScout = (state) => {

    if (!state.account_id) {
        return "Escolha uma origem"
    }

    if (state.format === MessageFormat.TEXT) {
        if (!state.message.length) {
            return "Digite uma mensagem"
        }
    } else if (state.format === MessageFormat.MEDIA) {
        if (!state.media && !state.media_url.length) {
            return "Selecione um arquivo ou coloque uma URL"
        }
        if (state.media && state.media.size > 10485760 * 3) {
            return "Arquivo muito grande, máximo 30MB"
        }
        if (state.media_url && !state.media_url.match(/^(http|https):\/\/[^ "]+$/)) {
            return "URL inválida"
        }
    } else {
        return "Selecione um formato"
    }

    return null
}

const SendScout = ({ title, handleClose, contacts, positionFixed }) => {
    
    const [state, setState] = useReducer(defaultReducer, {
        ...getScoutDefaultState,
        contacts: contacts,
    })
    const [loading, setLoading] = useState(false)

    const shouldSendScout = ShouldSendScout(state)
    return (
        <>
            <Loading loading={loading} />
            <Dialog
                open={true}
                disablePortal
                disableEnforceFocus
                onClose={() => {}}
                sx={{ position: positionFixed ? 'fixed': 'absolute' }}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
                    <span>{title ? title : "Enviar via Scout"}</span>
                    <Tooltip title="Fechar" >
                        <Button className="action-button">
                            <CloseIcon onClick={handleClose} />
                        </Button>
                    </Tooltip>
                </DialogTitle>
                <Divider />
                <DialogContent className={style.defaultSpacing}>
                    <SendScoutContent setParent={setState} parent={state} setLoading={setLoading} />
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        onClick={handleClose}
                        color="primary"
                    >
                        Cancelar
                    </LoadingButton>
                    <Tooltip title={shouldSendScout} placement="top" describeChild={true}>
                        <span><LoadingButton
                            onClick={() => submit(state, handleClose, setLoading)}
                            color="primary"
                            disabled={shouldSendScout}
                        >
                            Enviar
                        </LoadingButton></span>
                    </Tooltip>
                </DialogActions>
            </Dialog>
        </>
    )
};

export default SendScout;